/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CampaignsType from './CampaignsType';
import Reasons from './Reasons';
// import styles from '../EcsPortal.module.scss';

import OtpComponents from './OtpComponents';
import DisClaimer from './DisClaimer';
import styles from '../EcsPortal.module.scss';
import { CreateTicket } from '../../../api';
import { useAuth } from '../../../contexts/auth';
import { hasJdMartVertical } from '../../../lib/common';

export default function PrcHome(props) {
  const [authState] = useAuth();
  const { selectedBusiness, userDetails } = authState;
  const [currentComponent, setCurrentComponent] = useState(1);
  const [reasoncancel, setReasonCancel] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const [isUpdate, setIsUpdate] = useState(false);

  const [resultMessage, setResultMessage] = useState('');
  const [components, setComponents] = useState({});
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const { projectId, data, setData, isFaqChange, faqObj } = props;
  useEffect(() => {
    if (props.activeIndex !== -1) {
      setCurrentComponent(1);
      setData({
        campaigns: {},
        reasons: '',
        otp: '',
        disadvantage: 'disadvantage',
      });
      setResultMessage('');
    }
  }, [props.activeIndex]);

  const getSelectedCampaignNames = () => {
    return props?.campaigndetails && props?.campaigndetails?.length > 0
      ? props?.campaigndetails
          .filter((obj) => data?.campaigns[obj?.camp_id])
          .map((obj) => obj?.camp_name)
          .join(', ')
      : '';
  };

  const getCreateTicket = async (req) => {
    let issueComment = '';
    if (props?.faqObj?.extraText === 'stop') {
      const selectedCampaignNames = getSelectedCampaignNames();
      issueComment = `Campaign names: ${selectedCampaignNames}, \nReason: ${data?.reasons}`;
    }

    const params = {
      vertical: hasJdMartVertical() ? 'JD MART CORPORATE' : 'RETENTION',
      category: 'CS',
      ticket_creator: 'BUSINESS',
      nm:
        projectId === 'csportal'
          ? selectedBusiness?.compname
          : selectedBusinessGenio?.contractPersonName || selectedBusinessGenio?.companyName || '',
      created_by: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      mob: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
      issue_type: props.issue,
      issue_sub_type: props.subIssue,
      issue_comment: issueComment || '',
      document: [],
      city:
        projectId === 'genio'
          ? selectedBusinessGenio?.city || ''
          : queryParams.get('city') || selectedBusiness?.data_city,
      oid: '',
      orderid: '',
      docid:
        projectId === 'genio'
          ? selectedBusinessGenio?.docId || ''
          : queryParams.get('pid') || selectedBusiness?.docid || '',
      src: projectId === 'genio' ? 'sales-genio' : 'business',
      src_typ:
        projectId === 'genio' ? (selectedBusinessGenio?.concern === 'client' ? 'client' : 'internal') : 'csportal',
      src_nm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
      src_mob: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
      _type: req?.type || '',
      projectId: projectId === 'csportal' ? 1 : '',
      parentId: projectId === 'genio' ? selectedBusinessGenio?.parentId || '' : selectedBusiness?.parentid || '',
      compnm: projectId === 'genio' ? selectedBusinessGenio?.companyName || '' : selectedBusiness?.compname || '',
      bypass_autoclassify: data?.reasons ? 1 : 0,
      ...(projectId === 'genio' && {
        agent_mngr_id: profile?.reporteeCode,
        agent_id: profile?.empCode,
      }),
    };
    const res = await CreateTicket(params);
    if (res) {
      setResultMessage(res?.result?.msg);
    }
    setIsButtonClicked(false);
  };

  useEffect(() => {
    if (props.question.toLowerCase().includes('cancel')) {
      setComponents({
        1: (
          <DisClaimer
            data={data}
            setData={setData}
            status="cancel"
            currentComponent={currentComponent}
            setCurrentComponent={setCurrentComponent}
            setResultMessage={setResultMessage}
            getCreateTicket={getCreateTicket}
            setIsButtonClicked={setIsButtonClicked}
            isButtonClicked={isButtonClicked}
            projectId={projectId}
            faqObj={faqObj}
          />
        ),
        2: (
          <OtpComponents
            data={data}
            _amount={props.amount}
            status="cancel"
            campaigndetails={props.campaigndetails}
            setData={setData}
            currentComponent={currentComponent}
            setCurrentComponent={setCurrentComponent}
            setResultMessage={setResultMessage}
            getCreateTicket={getCreateTicket}
            setIsHelful={props.setIsHelful}
            getAllEcsDetails={props.getAllEcsDetails}
            projectId={projectId}
            faqObj={faqObj}
          />
        ),
      });
    } else {
      setComponents({
        1: (
          <CampaignsType
            setIsUpdate={setIsUpdate}
            isUpdate={isUpdate}
            campaigndetails={props.campaigndetails}
            ecsdetails={props.ecsdetails}
            faqdetails={props.faqdetails}
            data={data}
            reasoncancel={reasoncancel}
            activeIndex={props.activeIndex}
            setData={setData}
            status={props.question.toLowerCase().includes('reactivate') ? 'Reactivate' : 'stop'}
            currentComponent={currentComponent}
            setCurrentComponent={setCurrentComponent}
            setResultMessage={setResultMessage}
            getAllEcsDetails={props.getAllEcsDetails}
            projectId={projectId}
            isFaqChange={isFaqChange}
            faqObj={faqObj}
          />
        ),
        2: props.question.toLowerCase().includes('reactivate') ? (
          <OtpComponents
            data={data}
            campaigndetails={props.campaigndetails}
            setIsUpdate={setIsUpdate}
            isUpdate={isUpdate}
            _amount={props.amount}
            setData={setData}
            status="Reactivate"
            currentComponent={currentComponent}
            setCurrentComponent={setCurrentComponent}
            setResultMessage={setResultMessage}
            getCreateTicket={getCreateTicket}
            setIsHelful={props.setIsHelful}
            getAllEcsDetails={props.getAllEcsDetails}
            projectId={projectId}
            faqObj={faqObj}
          />
        ) : (
          <Reasons
            data={data}
            setData={setData}
            status={props.question.toLowerCase().includes('reactivate') ? 'Reactivate' : 'stop'}
            currentComponent={currentComponent}
            setCurrentComponent={setCurrentComponent}
            setResultMessage={setResultMessage}
            setReasonCancel={setReasonCancel}
            projectId={projectId}
            faqObj={faqObj}
          />
        ),
        3: props.question.toLowerCase().includes('reactivate') ? (
          <DisClaimer
            data={data}
            setData={setData}
            status="reactivate"
            setCurrentComponent={setCurrentComponent}
            currentComponent={currentComponent}
            setResultMessage={setResultMessage}
            getCreateTicket={getCreateTicket}
            setIsButtonClicked={setIsButtonClicked}
            isButtonClicked={isButtonClicked}
            projectId={projectId}
            faqObj={faqObj}
          />
        ) : (
          <DisClaimer
            data={data}
            setData={setData}
            status="stop"
            setCurrentComponent={setCurrentComponent}
            currentComponent={currentComponent}
            setResultMessage={setResultMessage}
            getCreateTicket={getCreateTicket}
            setIsButtonClicked={setIsButtonClicked}
            isButtonClicked={isButtonClicked}
            projectId={projectId}
            faqObj={faqObj}
          />
        ),
        4: props.question.toLowerCase().includes('reactivate') ? (
          ''
        ) : (
          <OtpComponents
            data={data}
            campaigndetails={props.campaigndetails}
            _amount={props.amount}
            setData={setData}
            status="stop"
            currentComponent={currentComponent}
            setCurrentComponent={setCurrentComponent}
            setResultMessage={setResultMessage}
            getCreateTicket={getCreateTicket}
            setIsHelful={props.setIsHelful}
            getAllEcsDetails={props.getAllEcsDetails}
            projectId={projectId}
            faqObj={faqObj}
          />
        ),
      });
    }
  }, [
    data,
    currentComponent,
    props.faqdetails,
    props.ecsdetails,
    props.campaigndetails,
    props.getAllEcsDetails,
    reasoncancel,
  ]);

  return (
    <>
      {!resultMessage ? (
        <div>{components[currentComponent]}</div>
      ) : (
        <>
          {resultMessage && (
            <div
              className={`${styles.Accordion__DotItem__Text} font12 fw400 color777`}
              style={{ height: 'fit-content' }}
              dangerouslySetInnerHTML={{ __html: resultMessage }}
            />
          )}
        </>
      )}
    </>
  );
}

PrcHome.propTypes = {
  campaigndetails: PropTypes.array,
  amount: PropTypes.string,
  question: PropTypes.string,
  subIssue: PropTypes.string,
  issue: PropTypes.string,
  activeIndex: PropTypes.number,
  setIsHelful: PropTypes.func,
  getAllEcsDetails: PropTypes.func,
  faqdetails: PropTypes.func,
  ecsdetails: PropTypes.object,
  projectId: PropTypes.string,
  faqObj: PropTypes.object,
  data: PropTypes.object,
  setData: PropTypes.func,
  isFaqChange: PropTypes.bool,
};
